export default __webpack_public_path__ + "static/media/TBT0227_Lean_Principles.d7baa44a.pdf";